// @ts-nocheck
import React from 'react';
import { Input, Textarea, Grid, Checkbox, AtsTip, SectionCard, AddButton, FormNav } from '../FormField';
import { ATS_TIPS } from '../../data/initialData';

export default function ExperienceTab({ data, onChange, onBack, onNext }) {
  const update = (idx, key, val) => {
    const arr = [...data];
    arr[idx] = { ...arr[idx], [key]: val };
    onChange(arr);
  };

  const add = () =>
    onChange([
      ...data,
      {
        id: Date.now(),
        company: '',
        role: '',
        location: '',
        startDate: '',
        endDate: '',
        current: false,
        bullets: '',
      },
    ]);

  const remove = (idx) => onChange(data.filter((_, i) => i !== idx));

  return (
    <div>
      
      {data.map((ex, i) => (
        <SectionCard
          key={ex.id}
          title="Experience"
          index={i}
          showRemove={data.length > 1}
          onRemove={() => remove(i)}
        >
          <Grid cols={2}>
            <Input
              label="Job Title / Role"
              required
              value={ex.role}
              onChange={(v) => update(i, 'role', v)}
              placeholder="Machine Learning Intern"
            />
            <Input
              label="Company"
              required
              value={ex.company}
              onChange={(v) => update(i, 'company', v)}
              placeholder="Flipkart"
            />
          </Grid>
          <Grid cols={3}>
            <Input
              label="Start Date"
              value={ex.startDate}
              onChange={(v) => update(i, 'startDate', v)}
              placeholder="May 2024"
            />
            <Input
              label="End Date"
              value={ex.endDate}
              onChange={(v) => update(i, 'endDate', v)}
              placeholder="Jul 2024"
              disabled={ex.current}
            />
            <Input
              label="Location"
              value={ex.location}
              onChange={(v) => update(i, 'location', v)}
              placeholder="Bengaluru, Karnataka"
            />
          </Grid>
          <Checkbox
            label="I currently work here"
            checked={ex.current}
            onChange={(v) => update(i, 'current', v)}
          />
          <Textarea
            label="Responsibilities & Achievements"
            hint="one bullet per line — start with action verbs"
            required
            value={ex.bullets}
            onChange={(v) => update(i, 'bullets', v)}
            placeholder={`Built a recommendation model in PyTorch that improved product click-through rate by 18% for 2M+ Flipkart users
Optimized feature engineering pipeline using Apache Spark, reducing training time from 6 hours to 45 minutes
Presented weekly model performance insights to product managers and senior ML scientists
Mentored 2 junior interns on Python best practices and ML experimentation workflows`}
            rows={6}
          />
        </SectionCard>
      ))}

      <AddButton onClick={add} label="Add Another Experience" />

      <FormNav showBack onBack={onBack} showNext onNext={onNext} nextLabel="Next: Projects →" />
    </div>
  );
}
